import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import { PageDetails } from '@codersclan/gatsby-theme-airfleet/src/@types';
import SearchSectionHelper from '../helpers/searchSectionHelper';

function usePage(slug: string) {
  // Hooks
  const {
    allWpPage,
  }: { allWpPage: { nodes: PageDetails[] } } = useStaticQuery(graphql`
    query MyQuery {
      allWpPage(
        filter: {
          slug: {
            in: [
              # Resources
              "resources"
              "research"
              "webinars"
              "learning"
              "blog"
              # Newsroom
              "newsroom"
              "news"
              "awards"
              "press"
            ]
          }
        }
      ) {
        nodes {
          id
          slug
          uri
          templateAllPages {
            sections {
              ...PreFooterCTAFragment
            }
          }
        }
      }
    }
  `);

  const page = React.useMemo(() => {
    let output = allWpPage.nodes.find(p => p.slug === slug);
    if (!output) {
      output = allWpPage.nodes.find(p => p.slug === 'resources');
    }
    return output;
  }, [allWpPage, slug]);

  return page;
}

export default usePage;
